<script setup lang="ts">
import { useRouteQuery } from "@vueuse/router";

type Price = {
  [key: string]: number;
};

const props = defineProps<{
  minimumPrice: Price;
  maximumPrice: Price;
}>();

const { activeCurrency } = useCurrencySwitcher();

const currencyIsoCode = computed(() =>
  activeCurrency.value.isoCurrencyCode.toLowerCase(),
);

const minPricePlaceholder = computed(() => {
  const minPrice = (props.minimumPrice?.[currencyIsoCode.value] ?? 0) / 100;

  return minPrice.toString();
});

const maxPrice = computed(() => {
  return (props.maximumPrice?.[currencyIsoCode.value] ?? 0) / 100;
});

const queryPriceFromValue = useRouteQuery("priceFrom", "", {
  transform: Number,
});

const queryPriceToValue = useRouteQuery("priceTo", "", {
  transform: Number,
});
</script>

<template>
  <div class="p-4">
    <h2 class="font-bold uppercase border-b pb-2">{{ $t("filter.price") }}</h2>
    <div class="flex flex-row gap-2 max-w-full mt-4 pb-3">
      <FormKit type="group">
        <BaseCurrencyInput
          v-model="queryPriceFromValue"
          data-test="from-price-filter"
          :placeholder="minPricePlaceholder"
          type="number"
          name="minPrice"
          :min="0"
          :max="maxPrice"
          inputmode="numeric"
          inner-class="!bg-white"
          input-class="!bg-white"
          outer-class="w-1/2"
        />
        <BaseCurrencyInput
          v-model="queryPriceToValue"
          data-test="to-price-filter"
          :placeholder="maxPrice.toString()"
          type="number"
          name="maxPrice"
          :min="0"
          :max="maxPrice"
          inputmode="numeric"
          inner-class="!bg-white"
          input-class="!bg-white"
          outer-class="w-1/2"
        />
      </FormKit>
    </div>
  </div>
</template>
